import React, { useContext, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import {
    Box,
    CssBaseline,
    Stack,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { Tabs, Tab } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

import TopHeader from '../../../../components/general/TopHeader';


import { AuthenticationContext } from '../../../../context/AuthenticationContext';
import TransformerHealthTab1 from './TransformerTabs/TransformerHealthTab1';
import TransformerHealthTab2 from './TransformerTabs/TransformerHealthTab2';
import TransformerHealthTab3 from './TransformerTabs/TransformerHealthTab3';






export default function TransformerHealth() {
    const { LoggedInUserInfo } = useContext(AuthenticationContext);
    const { palette, breakpoints, spacing } = useTheme();
    const matches = useMediaQuery(breakpoints.up('lg'));
    const [key, setKey] = useState('Live');
    const location = useLocation();

    useEffect(() => {
        if (LoggedInUserInfo?.Welcome_msg?.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Web Portal Subscription Status',
                html: LoggedInUserInfo.Welcome_msg,
                confirmButtonText: 'OK',
                width: "25rem",
                
                
                customClass: {
                    popup: 'custom-swal-popup',
                    title: 'custom-swal-title',
                    htmlContainer: 'custom-swal-html'
                }
            });
        }
    }, [LoggedInUserInfo?.Welcome_msg]);
    

    function handleClick(event) {
        event.preventDefault();
        // console.info('You clicked a breadcrumb.');
    }

    return (
        <>
            <CssBaseline />
            <TopHeader />
            <Box mt={spacing(1)}>
                <Stack direction={'row'} sx={{ position: 'absolute', columnGap: spacing(1) }} role="presentation" onClick={handleClick}>
                    <NavLink style={{ textDecoration: "none", color: palette.primary.main }}>
                        Transformer Health
                    </NavLink>
                </Stack>

                <Tabs
                    style={{ justifyContent: "flex-end" }}
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                >
                    <Tab eventKey="Live" title="Live">
                      <TransformerHealthTab1/>
                    </Tab>

                    <Tab eventKey="Log" title="Log">
                        <TransformerHealthTab2/>
                    </Tab>

                    <Tab eventKey="Mis" title="Mis">
                        <TransformerHealthTab3/>
                    </Tab>
                   
                   
                    
                </Tabs>
            </Box>
        </>
    );
}